export const LIVE_COLLABORATION_STORE_NAME = 'liveCollaborationStore';

// Socket Actions
export const LIVE_COLLABORATION_SOCKET_CONNECT = 'LIVE_COLLABORATION_SOCKET_CONNECT';
export const LIVE_COLLABORATION_SOCKET_DISCONNECT = 'LIVE_COLLABORATION_SOCKET_DISCONNECT';
export const LIVE_COLLABORATION_SOCKET_UPDATE_CHANNEL = 'LIVE_COLLABORATION_SOCKET_UPDATE_CHANNEL';
